"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ENTERPRISE = exports.PROFESSIONAL = exports.STARTER = exports.FREE = void 0;
var FREE = 'free';
exports.FREE = FREE;
var STARTER = 'starter';
exports.STARTER = STARTER;
var PROFESSIONAL = 'professional';
exports.PROFESSIONAL = PROFESSIONAL;
var ENTERPRISE = 'enterprise';
exports.ENTERPRISE = ENTERPRISE;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/constants/Editions.js
// module id = 26
// module chunks = 5 6 7